import React, { useState, useEffect } from "react";
import New from "../../assets/assets/apply-new.svg";
import Empty from "../../assets/assets/empty-card.svg";
import { Link, useHistory } from "react-router-dom";
import Close from "../../assets/assets/close.svg";
import chip from "../../assets/assets/chips.png";
import nfc from "../../assets/assets/nfc.svg";
import Forward from "../../assets/assets/forward.svg";
import { connect } from "react-redux";
import { applyForTestCard } from "../../redux/Actions/PosActions";
import Loader from "../../components/Loader/Loader";
import { PropTypes } from "prop-types";

export const TestCard = ({
  results,
  categoryChoice,
  isApplying,
  applyCardSuccess,
  appId,
  testCardStatus,
  userType,
  resultsLength,
  expired
}) => {
  const history = useHistory();

  const [state, setState] = useState({
    showModal: false,
    showTestModal: false,
  });

  const initializeRequest2 = () => {
    history.push({
      pathname: "/payment-testcard",
      state: {
        id: appId,
      },
    });
  };

  const openTestModal = () => {
    setState({
      ...state,
      showTestModal: true,
    });
  };

  const hideTestModal = () => {
    setState({
      ...state,
      showTestModal: false,
    });
  };

  useEffect(
    () => {
      if (applyCardSuccess) {
        setState({
          ...state,
          showModal: true,
        });
      }
    },
    // eslint-disable-next-line
    [applyCardSuccess]
  );

  const res = (str) => {
    let newStr = str.split("_").join(" ");
    return newStr;
  };

  const seperateNo = (str) => {
    let newNo =
      str &&
      str
        .replace(/[^\dA-Z]/g, "")
        .replace(/(.{4})/g, "$1 ")
        .trim();
    return newNo;
  };

  const newresults =
    results &&
    results[0] &&
    results[0].card_request &&
    results[0].card_request[0] &&
    results[0].card_request[0].card_details &&
    results[0].card_request[0].card_details.slice(0, 2);

  return (
    <div className="product-right">
      <div className="pos-doc-sec-right">
        <p>What's new</p>
        <div className="pos-doc-sec-right-image">
          <img src={New} alt="icon" />
        </div>
        <h3>
          Get POS <br /> Certification now
        </h3>
        <Link to="/apply">
          <button
            disabled={
              (categoryChoice !== 1 &&
                categoryChoice !== 3 &&
                 categoryChoice !== 7 &&
                categoryChoice !== 4) ||
              userType === "staff" || expired
            }
          >
            APPLY NOW
          </button>
        </Link>
      </div>
      <br />
      <br />

      <div className="pos-doc-sec-bottom">
        <div className="pos-doc-sec-bottom-title">
          <h3>Test Cards</h3>
          {results && results.length > 0 && (
            <span data-testid="openTestModal" onClick={() => openTestModal()}>
              See all &nbsp; <img src={Forward} alt="icon" />
            </span>
          )}
        </div>

        {state.showTestModal && (
          <div className="test-results">
            <div className="test-results-title">
              <span>My Test Cards</span>
              <div
                className="image"
                data-testid="hideTestModal"
                onClick={() => hideTestModal()}
              >
                <img src={Close} alt="close" />
              </div>
            </div>
            <div className="test-results-content">
              {results &&
                results.map(
                  (result, index) =>
                    result.card_request &&
                    result.card_request.map(
                      (item, index) =>
                        item.card_details &&
                        item.card_details.map((card, index) => (
                          <div
                            className="test-results-content-item"
                            key={card.card_details_id}
                          >
                            <div className="above">
                              <div className="header">
                                <h1>Test Card {index + 1}</h1>
                                <p>{res(card.card_type)} card</p>
                              </div>

                              <div className="mid">
                                <div className="mid-mid">
                                  <div className="chip">
                                    <img src={chip} alt="chip" />
                                  </div>
                                  <div>
                                    <div className="mid-sec">
                                      <h2>EXPIRY:</h2>{" "}
                                      <span>{card.expiry_date}</span>
                                    </div>
                                    <div className="mid-sec">
                                      <h2>PIN:</h2> <span>{card.cvv}</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <h3>{seperateNo(card.pan)}</h3>
                            </div>
                            <div className="below">
                              <div className="chip2">
                                <img src={nfc} alt="chip" />
                              </div>
                            </div>
                          </div>
                        ))
                    )
                )}
            </div>
          </div>
        )}

        <>
          {results && results.length === 0 && (
            <>
              <div className="empty-card">
                <div className="empty-card-section">
                  <div className="empty-card-section-image">
                    <div className="empty-card-section-image-div">
                      <img src={Empty} alt="empty-card" />
                    </div>
                    <p>No test cards</p>
                  </div>
                </div>
              </div>
            </>
          )}
        </>
        {resultsLength && Object.keys(resultsLength).length !== 0 && (
          <div className="card-spec">
            <div className="test-results-full">
              {newresults &&
                newresults.map((card, index) => (
                  <div
                    className="test-results-full-item"
                    key={card.card_details_id}
                  >
                    <div className="above">
                      <div className="header">
                        <h1>Test Card {index + 1}</h1>
                        <p>{res(card.card_type)} card</p>
                      </div>

                      <div className="mid">
                        <div className="mid-mid">
                          <div className="chip">
                            <img src={chip} alt="chip" />
                          </div>
                          <div>
                            <div className="mid-sec">
                              <h2>EXPIRY:</h2> <span>{card.expiry_date}</span>
                            </div>
                            <div className="mid-sec">
                              <h2>PIN:</h2> <span>{card.cvv}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <h3>{seperateNo(card.pan)}</h3>
                    </div>
                    <div className="below">
                      <div className="chip2">
                        <img src={nfc} alt="chip" />
                      </div>
                    </div>
                  </div>
                ))}
            </div>
            {testCardStatus >= 1 && (
              <button
                className="empty-card-button"
                data-testid="emptyCard"
                onClick={() => initializeRequest2()}
                disabled={isApplying || userType === "staff"}
              >
                {isApplying ? <Loader /> : "REQUEST FOR A NEW CARD"}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isApplying: state.pos.isApplying,
    applyCardSuccess: state.pos.applyCardSuccess,
  };
};

const mapDispatchToProps = (dispatch) => ({
  applyForTestCard: (payload) => dispatch(applyForTestCard(payload)),
});

TestCard.propTypes = {
  results: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  categoryChoice: PropTypes.number,
  isApplying: PropTypes.bool,
  applyCardSuccess: PropTypes.bool,
  appId: PropTypes.number,
  testCardStatus: PropTypes.number,
  userType: PropTypes.string,
  resultsLength: PropTypes.array,
};

export default connect(mapStateToProps, mapDispatchToProps)(TestCard);
